"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function svgParcel(shape, width = 100, height = 100, stroke, fill) {
    if (!shape) {
        return svgCircle(width, height);
    }
    const polygons = extractPolygons(shape);
    const paths = [];
    let allPoints = [];
    polygons.forEach(p => {
        allPoints = allPoints.concat(polygon_parse(p));
    });
    allPoints = polygon_projection(allPoints);
    polygons.forEach(polygon => {
        let points = polygon_parse(polygon);
        points = polygon_projection(points);
        points = polygon_normalize(allPoints, points, width, height, 5);
        let path = '';
        points.forEach((p, i) => {
            path += i === 0 ? 'M ' : 'L ';
            path += p[0] + ' ' + p[1] + ' ';
        });
        paths.push(path);
    });
    let svgPaths = '';
    paths.forEach(path => {
        svgPaths += `<path d="${path}" />`;
    });
    if (stroke && fill) {
        return `
        <svg width="${width}" height="${height}" stroke="${stroke}" fill="${fill}" xmlns="http://www.w3.org/2000/svg">
            ${svgPaths}
        </svg>     
    `;
    }
    else {
        return `
        <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg">
            ${svgPaths}
        </svg>     
    `;
    }
}
exports.default = svgParcel;
function svgCircle(width, height) {
    const cx = width / 2;
    const cy = height / 2;
    const r = Math.min(cx, cy) * 0.75;
    return `
        <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg">
            <circle cx="${cx}" cy="${cy}" r="${r}" />
        </svg>     
    `;
}
function extractPolygons(shape) {
    // Remove "POLYGON" or "MULTIPOLYGON" and the outer parenthesis
    shape = shape.replace(/^(POLYGON|MULTIPOLYGON)\s*\(/, '')
        .replace(/\)$/, '')
        .replace(/,\s+/g, ',');
    // Separate the different polygons
    const polygons = shape.split(')),((');
    // Clear and separate coordinates of each polygon
    return polygons.map(polygon => {
        return polygon.replace(/[()]/g, '')
            .trim().split(',').map(coords => coords.trim());
    });
}
function polygon_parse(poly) {
    return poly.map((point) => {
        return point.split(' ').map(p => +p);
    });
}
function polygon_projection(points) {
    //
    // Pseudo-Mercator projection functions
    //
    // https://wiki.openstreetmap.org/wiki/Mercator
    const RAD2DEG = 180 / Math.PI;
    const PI_4 = Math.PI / 4;
    const lat2y = (lat) => Math.log(Math.tan((lat / 90 + 1) * PI_4)) * RAD2DEG;
    const lon2x = (lon) => lon;
    //
    // Transform the points from coordinates to map positions
    //
    return points.map(([x, y]) => {
        return [
            lon2x(x),
            lat2y(y * -1) // TODO
        ];
    });
}
function polygon_normalize(points, pointsToNormalize, width, height, margin = 0) {
    width -= margin * 2;
    height -= margin * 2;
    // Get the min max points
    let min_a = points[0][0];
    let max_a = points[0][0];
    let min_b = points[0][1];
    let max_b = points[0][1];
    for (const p of points) {
        min_a = Math.min(p[0], min_a);
        max_a = Math.max(p[0], max_a);
        min_b = Math.min(p[1], min_b);
        max_b = Math.max(p[1], max_b);
    }
    // Calculate the scale
    const diff_a = max_a - min_a;
    const diff_b = max_b - min_b;
    // The >0 check is to avoid a division by zero when all the points are in a line
    const scale_a = (diff_a > 0) ? width / diff_a : 100000;
    const scale_b = (diff_b > 0) ? height / diff_b : 100000;
    const scale = Math.min(scale_a, scale_b);
    const size_a = diff_a * scale;
    const size_b = diff_b * scale;
    const offset_a = (width - size_a) / 2;
    const offset_b = (height - size_b) / 2;
    //
    // Do normalize
    //
    return pointsToNormalize.map((p) => [
        (p[0] - min_a) * scale + offset_a + margin,
        (p[1] - min_b) * scale + offset_b + margin
    ]);
}
